module.exports = __webpack_public_path__ + "images/emoji/last_quarter_moon.b3bc008e8798a0f5c54f.png";